<div class="modal-header ps-5 pt-5 pe-5">
  <h3 class="modal-title text-center"><i class="fas fa-fw fa-user-unlock me-2"></i> Donner accès à ce calcul au
support d'Optitax?</h3>
</div>
<div class="modal-body ps-5 pe-5">
  <div class="row align-items-center">
    <div class="col-auto">
      <p>Cette option va partager ce calcul avec le support d'Optitax. <strong>Activer cette fonctionnalité
        uniquement si
      vous êtes en train de communiquer avec le support client Optitax.</strong></p>

      @if (accessCurrentlyGranted === false) {
        <div class="alert alert-light mt-4 mb-5">
          <strong>Important!</strong> Vous pouvez désactiver l'accès à tout
          moment en revenant sur cette page.
        </div>
      }

      @if (accessCurrentlyGranted) {
        <div class="alert alert-warning mt-4 mb-5">
          <h3><i class="fas fa-fw fa-info-circle me-2"></i> Partage avec le support d'Optitax en cours!</h3>
          <p>Ce calcul est présentement partagé avec le support d'Optitax. Le partage se terminera automatiquement
            <strong>{{ this.grantedUntil }}</strong>.</p>
            @if (accessCurrentlyGranted) {
              <button (click)="stopDelegatingAccess()" class="btn btn-danger btn-sm mt-1">
                Arrêter le partage
              </button>
            }
          </div>
        }

        <h3 class="mt-4">Donner accès pendant:</h3>

        <div class="btn-group-toggle mt-3 mb-5">
          <fieldset [disabled]="state === 'LOADING' || state === 'REFRESHING'">
            <input [formControl]="delegatedDuration" [readOnly]="state === 'LOADING' || state === 'REFRESHING'"
              autocomplete="off" checked="checked" class="btn-check"
              id="hour" name="delegatedDuration"
              type="radio" value="28800000">
            <label class="btn btn-white" for="hour">
              <i class="fe fe-clock"></i> 8 heures
            </label>
            <input [formControl]="delegatedDuration" [readOnly]="state === 'LOADING' || state === 'REFRESHING'"
              autocomplete="off" class="btn-check" id="day"
              name="delegatedDuration"
              type="radio" value="86400000">
            <label class="btn btn-white" for="day">
              <i class="far fa-calendar-day"></i> 1 journée
            </label>
            <input [formControl]="delegatedDuration" [readOnly]="state === 'LOADING' || state === 'REFRESHING'"
              autocomplete="off" class="btn-check" id="week"
              name="delegatedDuration"
              type="radio" value="604800000">
            <label class="btn btn-white" for="week">
              <i class="far fa-calendar-week"></i> 1 semaine
            </label>
          </fieldset>
        </div>

        @if (state === 'LOADING' || state === 'REFRESHING') {
          <div class="alert alert-primary">
            <span class="spinner-border spinner-border-sm me-3" role="status"></span>
            Mise à jour des permissions en cours...
          </div>
        }

      </div>

    </div>
    <div class="modal-footer">
      <button (click)="activeModal.close()" class="btn btn-white" type="button">Annuler</button>
      <button (click)="this.delegateAccess()" [disabled]="state === 'LOADING' || state === 'REFRESHING'"
        class="btn btn-primary"
        type="button">
        @if (state === 'LOADING' || state === 'REFRESHING') {
          <span aria-hidden="true"
            class="spinner-border spinner-border-sm"
          role="status"></span>
        }
        Donner accès au support Optitax
      </button>
    </div>
  </div>
